/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const solutionDescriptionDtoSchema = z.object({
  lead: z.optional(z.string()),
  paragraphs: z.optional(z.array(z.string())),
});
